document.addEventListener("DOMContentLoaded", () => {
  //localStorage.removeItem('bundlePropertiesValue');

  const propertiesValues = localStorage.getItem('bundlePropertiesValue');

  if (!propertiesValues) return;

  const propertiesValueArray = JSON.parse(propertiesValues);

  if (!Array.isArray(propertiesValueArray) || propertiesValueArray.length === 0) return;

  // console.log('Properties bundle:', propertiesValueArray); 

  const BUNDLE_TITLE = propertiesValueArray;

  // console.log('Stored properties:', BUNDLE_TITLE);

  const CART_DRAWER_SELECTOR = '.drawer--container[data-view="cart-drawer"]';

  const cartBody = document.querySelector(
    `${CART_DRAWER_SELECTOR} .cart--body`,
  );

  if (!cartBody) return;

  let isProcessingBundleRemoval = false;

  /**
   * Get latest cart
   */
  async function getCart() {
    const response = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch cart");
    }

    return response.json();
  }

  /**
   * Create a simple cart signature.
   * We use key + quantity so we can detect
   * when Shopify/theme has finished changing cart.
   */
  function getCartSignature(cart) {
    return cart.items
      .map((item) => `${item.key}:${item.quantity}`)
      .sort()
      .join("|");
  }

  /**
   * Wait until cart is changed by theme's
   * original remove functionality.
   */
  async function waitForCartUpdate(
    previousCartSignature,
    timeout = 5000,
    interval = 100,
  ) {
    const startTime = Date.now();

    while (Date.now() - startTime < timeout) {
      try {
        const latestCart = await getCart();

        const latestSignature = getCartSignature(latestCart);

        if (latestSignature !== previousCartSignature) {
          console.log("Cart update detected");

          return latestCart;
        }
      } catch (error) {
        console.warn("Waiting for cart update:", error);
      }

      await new Promise((resolve) => setTimeout(resolve, interval));
    }

    // console.warn("Cart update timeout");

    // Return latest cart anyway
    return getCart();
  }

  /**
   * Remove all remaining bundle items
   * with the same variant title.
   *
   * IMPORTANT:
   * We get the latest cart first, so we use
   * the NEW cart item keys.
   */
  async function removeBundleCartItems(variantTitle, previousCart, productTitle) {
    try {
      const previousSignature = getCartSignature(previousCart);

      // Wait for theme's remove operation
      const latestCart = await waitForCartUpdate(previousSignature);

      // console.log("Latest cart after theme update:", latestCart.items);

      /**
       * Find remaining bundle items using
       * latest cart data and latest keys.
       */
      const bundleItems = latestCart.items.filter((item) => {
        const bundleTitle = item.properties?.Bundle?.trim() || '';
        // console.log("Item: ", bundleTitle, productTitle);
        return (
          bundleTitle &&
          bundleTitle === productTitle &&
          item.variant_title === variantTitle
        );
      });

      // console.log("Length: ", bundleItems.length);

      if (!bundleItems.length) {
        // console.log("No remaining matching bundle items found");

        await refreshCustomCartDrawer();
        await updateCartItemCount();

        return;
      }

      // console.log("Remaining bundle items:", bundleItems);

      /**
       * Use NEW keys from latest cart
       */
      const updates = Object.fromEntries(
        bundleItems.map((item) => [item.key, 0]),
      );

      // console.log("Bulk removing with latest keys:", updates);

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates,
        }),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to remove bundle items: ${await response.text()}`,
        );
      }

      console.log("Remaining matching bundle items removed");

      await refreshCustomCartDrawer();
      await updateCartItemCount();
    } catch (error) {
      console.error("Failed to remove bundle products:", error);
    }
  }

  /**
   * Refresh cart drawer HTML
   */
  async function refreshCustomCartDrawer() {
    try {
      const response = await fetch("/cart", {
        headers: {
          Accept: "text/html",
        },
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error("Unable to load cart HTML");
      }

      const html = await response.text();

      const parser = new DOMParser();

      const newDocument = parser.parseFromString(html, "text/html");

      const newCart = newDocument.querySelector(
        `${CART_DRAWER_SELECTOR} .cart--root`,
      );

      const currentCart = document.querySelector(
        `${CART_DRAWER_SELECTOR} .cart--root`,
      );

      if (!newCart || !currentCart) {
        return;
      }

      currentCart.replaceWith(newCart.cloneNode(true));

      // console.log("Cart drawer updated");
      // console.log("bundle: ", updates);

      disableBundleQuantityControls();
    } catch (error) {
      console.error("Failed to refresh custom cart drawer:", error);
    }
  }

  /**
   * Update cart item count
   */
  async function updateCartItemCount() {
    try {
      const cart = await getCart();

      const cartButton = document.querySelector(
        '.header--cart[data-drawer-open="right"][data-drawer-view="cart-drawer"]',
      );

      if (!cartButton) {
        return;
      }

      cartButton.setAttribute("data-cart-count", cart.item_count);

      // console.log("Cart count updated:", cart.item_count);
    } catch (error) {
      console.error("Failed to update cart count:", error);
    }
  }

  /**
   * Disable quantity controls for bundle items
   */
  function disableBundleQuantityControls() {
    const cartItems = document.querySelectorAll(
      `${CART_DRAWER_SELECTOR} .cart--item`,
    );

    cartItems.forEach((cartItem) => {
      const properties = cartItem.querySelector(".cart--item-properties");

      if (!properties) return;

      const bundleText = properties.innerText
        .replace("Bundle:", "")
        .trim();

      if (!BUNDLE_TITLE.includes(bundleText)) return;

      const quantityContainer = cartItem.querySelector(
        ".cart--item--quantity .quantity-selector--container",
      );

      if (!quantityContainer) return;

      quantityContainer.style.pointerEvents = "none";

      quantityContainer.style.opacity = 0.5;

      console.log("No other item left");
    });
  }

  /**
   * Handle remove click
   */
  document.addEventListener("click", async (event) => {
    const removeButton = event.target.closest(
      `${CART_DRAWER_SELECTOR} .quantity-selector--remove`,
    );

    if (!removeButton) return;

    /**
     * Prevent multiple custom processes
     */
    if (isProcessingBundleRemoval) return;

    /**
     * Get cart BEFORE theme's remove handler
     */
    const previousCart = await getCart();

    const remove_dataset = removeButton.dataset?.name;

    console.log("DATASET: ", remove_dataset);

    /**
     * Get variant title from clicked cart item
     */
    const grandParent = removeButton.parentElement?.parentElement;

    if (!grandParent) return;

    const firstSibling = grandParent.parentElement?.children[0];

    if (!firstSibling) return;

    const variantTitleElement = firstSibling.children[0];

    if (!variantTitleElement) return;

    const variantTitle = variantTitleElement.textContent.trim();

    isProcessingBundleRemoval = true;

    try {
      /**
       * Theme's remove event is already running
       * in parallel.
       *
       * We wait for the cart itself to change.
       */
      await removeBundleCartItems(variantTitle, previousCart, remove_dataset);
    } finally {
      isProcessingBundleRemoval = false;
    }
  });

  /**
   * Observe cart drawer changes
   */
  const observer = new MutationObserver(() => {
    disableBundleQuantityControls();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /**
   * Initial setup
   */
  disableBundleQuantityControls();
});

document.addEventListener("DOMContentLoaded", () => {

  if (!window.location.pathname.includes("/cart")) return;

  const CART_SELECTOR = ".template--cart .shopify-section.section--cart";

  const FORM_SELECTOR = ".cart--form";
  
  const propertiesValues = localStorage.getItem('bundlePropertiesValue');

  if (!propertiesValues) return;

  const propertiesValueArray = JSON.parse(propertiesValues);

  if (!Array.isArray(propertiesValueArray) || propertiesValueArray.length === 0) return;

  // console.log('Properties bundle:', propertiesValueArray); 

  const BUNDLE_TITLE = propertiesValueArray;

  let observerTimeout = null;

  let isProcessingBundleRemoval = false;

  /**
   * Get latest cart
   */
  async function getCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error("getCart() error:", error);
      throw error;
    }
  }

  /**
   * Create a simple cart signature.
   * We use key + quantity so we can detect
   * when Shopify/theme has finished changing cart.
   */
  function getCartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return "";
    }
    return cart.items
      .map((item) => {
        const properties = Object.entries(item.properties || {})
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([key, value]) => `${key}:${value}`)
          .join(",");
        return [item.key, item.variant_id, item.quantity, properties].join(":");
      })
      .sort()
      .join("|");
  }

  /**
   * Wait until cart is changed by theme's
   * original remove functionality.
   */
  async function waitForCartUpdate(
    previousCartSignature,
    timeout = 6000,
    interval = 100,
  ) {
    const startTime = Date.now();
    while (Date.now() - startTime < timeout) {
      try {
        const latestCart = await getCart();
        const latestSignature = getCartSignature(latestCart);
        /** * Cart changed */ if (
          latestSignature &&
          latestSignature !== previousCartSignature
        ) {
          // console.log("Cart update detected:", {
          //   previous: previousCartSignature,
          //   latest: latestSignature,
          // });
          return latestCart;
        }
      } catch (error) {
        console.warn("Waiting for cart update:", error);
      }
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
    /** * Timeout reached. * * Return latest cart instead of returning * an old/stale cart. */
    try {
      const latestCart = await getCart();
      console.warn("Cart update timeout. Returning latest cart.");
      return latestCart;
    } catch (error) {
      console.error("Unable to get latest cart after timeout:", error);
      return null;
    }
  }

  async function removeBundleCartItems(
    variantTitle,
    previousCart,
    CART_LAYOUT,
    PACK_NAME,
  ) {
    try {
      const previousSignature = getCartSignature(previousCart);

      // Wait for theme's remove operation
      const latestCart = await waitForCartUpdate(previousSignature);

      // console.log("Latest cart after theme update:", latestCart.items,);

      /**
       * Find remaining bundle items using
       * latest cart data and latest keys.
       */
      const bundleItems = latestCart.items.filter((item) => {
        // console.log("Variant:", item.variant_title);
        // console.log("Target Variant:", variantTitle);
        const bundleTitle = item.properties?.Bundle?.trim() || '';
        return (
          bundleTitle &&
          bundleTitle === PACK_NAME &&
          (item.variant_title || "").trim().toLowerCase() ===
            (variantTitle || "").trim().toLowerCase()
        );
      });

      console.log("Remaining bundle:", bundleItems);

      if (!bundleItems.length) {
        // console.log("No remaining matching bundle items found");

        await refreshCustomCartDrawer(CART_LAYOUT);
        await updateCartItemCount();

        return;
      }

      // console.log("Remaining bundle items:", bundleItems);

      /**
       * Use NEW keys from latest cart
       */
      const updates = Object.fromEntries(
        bundleItems.map((item) => [item.key, 0]),
      );

      // console.log("Bulk removing with latest keys:", updates);

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates,
        }),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to remove bundle items: ${await response.text()}`,
        );
      }

      // console.log("Remaining matching bundle items removed");

      await refreshCustomCartDrawer(CART_LAYOUT);
      await updateCartItemCount();
    } catch (error) {
      console.error("Failed to remove bundle products:", error);
    }
  }

  /**
   * Refresh cart drawer HTML
   */
  async function refreshCustomCartDrawer(layout) {
    console.log("layout: ", layout);
    try {
      const response = await fetch("/cart", {
        headers: {
          Accept: "text/html",
        },
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error("Unable to load cart HTML");
      }

      const html = await response.text();

      const parser = new DOMParser();

      const newDocument = parser.parseFromString(html, "text/html");

      // console.log("CART: ", newDocument);

      const newCart = newDocument.querySelector(`${layout}`);

      const currentCart = document.querySelector(`${layout}`);

      if (!newCart || !currentCart) {
        return;
      }

      currentCart.replaceWith(newCart.cloneNode(true));

      // console.log("Cart drawer updated");
      // console.log("bundle: ", updates);
    } catch (error) {
      console.error("Failed to refresh custom cart drawer:", error);
    }
  }

  async function updateCartItemCount() {
    try {
      const cart = await getCart();

      const cartButton = document.querySelector(
        '.header--cart[data-drawer-open="right"][data-drawer-view="cart-drawer"]',
      );

      if (!cartButton) {
        return;
      }

      cartButton.setAttribute("data-cart-count", cart.item_count);

      setTimeout(() => {
        window.location.reload();
      }, 100);

      // console.log("Cart count updated:", cart.item_count);
    } catch (error) {
      console.error("Failed to update cart count:", error);
    }
  }

  const processCart = () => {
    const cartSection = document.querySelector(CART_SELECTOR);

    if (!cartSection) return false;

    const isDesktop = window.innerWidth > 768;

    const cartView = cartSection.querySelector(
      `.cart--root[data-view="${isDesktop ? "desktop" : "mobile"}"]`,
    );

    const cartLayout = isDesktop
      ? '.cart--root[data-view="desktop"]'
      : '.cart--root[data-view="mobile"]';

    if (!cartView) return false;

    const formLayout = cartView.querySelector(FORM_SELECTOR);

    if (!formLayout || getComputedStyle(formLayout).display === "none") {
      return false;
    }

    const cartItems = formLayout.querySelectorAll(".cart--body .cart--item");

    if (!cartItems.length) return false;

    cartItems.forEach((item, index) => {
      const bundleProperties = item.querySelector(".cart--item-properties");

      if (!bundleProperties) return;

      const bundleText = bundleProperties.innerText
        .replace("Bundle:", "")
        .trim();

      if (!BUNDLE_TITLE.includes(bundleText)) return;

      // Disable quantity controls
      const quantityContainer = item.querySelector(
        ".quantity-selector--container",
      );

      if (quantityContainer) {
        quantityContainer.style.pointerEvents = "none";
        quantityContainer.style.opacity = "0.5";
      }

      // Find remove button
      const removeBtn = item.querySelector(
        ".quantity-selector--remove.remove-all-same--properties-name",
      );

      if (!removeBtn) return;

      if (
        removeBtn.dataset.listenerAttached === "true" ||
        !BUNDLE_TITLE.includes(removeBtn.dataset.name)
      ) {
        return;
      }

      removeBtn.dataset.listenerAttached = "true";

      removeBtn.addEventListener("click", async (event) => {
        const removeButton = event.currentTarget;

        // const variantTitleElement = bundleProperties.previousElementSibling;

        const variantTitleElement =
          item.querySelector(".cart--item--variant-name")?.innerText?.trim() ||
          "";

        if (!variantTitleElement) return;

        /**
         * Prevent multiple custom processes
         */
        if (isProcessingBundleRemoval) return;

        /**
         * IMPORTANT:
         * Set this BEFORE the async request.
         */
        isProcessingBundleRemoval = true;

        try {
          /**
           * Get cart BEFORE theme's remove operation.
           */
          const previousCart = await getCart();

          const pack_name = removeButton.dataset?.name;

          console.log("REMOVE:", pack_name, cartView, cartLayout);
          console.log("INDEX:", index);
          console.log("VARIANT:", variantTitleElement);

          /**
           * Theme's remove event is already running
           * in parallel.
           *
           * We wait for the cart itself to change.
           */
          await removeBundleCartItems(
            variantTitleElement,
            previousCart,
            cartLayout,
            pack_name,
          );
        } finally {
          isProcessingBundleRemoval = false;
        }
      });
    });

    return true;
  };

  // Initial processing
  processCart();

  // Watch Shopify cart DOM updates
  const observer = new MutationObserver(() => {
    if (observerTimeout) {
      cancelAnimationFrame(observerTimeout);
    }

    observerTimeout = requestAnimationFrame(() => {
      processCart();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
